import React from 'react';

const Btn = ( { disabled, children } ) => {
    return (
        <div className={`btn ${disabled ? 'disabled' : ''}`}>{children}</div>
    );
};
export default Btn;
